export const SETTLEMENTS_REPORT_LOADINGS = {
  GET_REPORT: "loadingSettlementsReport"
};

export const reportSettlementsTypes = {
  SET_SETTLEMENTS_REPORT_FILTERS: "SETTLEMENTS_REPORT/SET_FILTERS",
  RESTORE_INITIAL: "SETTLEMENTS_REPORT/RESTORE_INITIAL",
};
